module.exports = __webpack_public_path__ + "static/media/EVERYTIME_01.d19dd7da.png";